// Slide to the relevant menu collection
document.querySelectorAll(".promotion-slider .card-list").forEach((link) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    const targetTitle = this.getAttribute("title");
    const targetBlock = document.getElementById(targetTitle);

    if (targetBlock) {
      targetBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});

// PDF Block
// const cards = document.getElementsByClassName("card");
// const popdetails = document.querySelectorAll(".pop-details");

// for (let i = 0; i < cards.length; i++) {
//   cards[i].addEventListener("click", function () {
//     popdetails.forEach(p => p.style.display = "none");
//     popdetails[i].style.display = "flex";    
//   });
// }

// // Close popup when clicking on close button
// document.querySelectorAll(".closePop").forEach(btn => {
//   btn.addEventListener("click", function () {
//     this.closest(".pop-details").style.display = "none";
//   });
// });+


const cards = document.querySelectorAll(".card");
const popdetails = document.querySelectorAll(".pop-details");

cards.forEach((card, index) => {

  card.addEventListener("click", function () {
    const isLink = card?.dataset?.link === "true";
    const href = card?.getAttribute("href");
    const target = card?.getAttribute("target");
    if (isLink && href) {
      if (target === "_blank") {
        window.open(href, "_blank");
      } else {
        window.location.href = href;
      }
      return;
    }

    // hide all popups
    popdetails.forEach(popup => {
      popup.style.display = "none";
    });

    // show correct popup
    if(popdetails[index]){
      popdetails[index].style.display = "block";
    }

  });

});

// close popup
document.querySelectorAll(".closePop").forEach(btn => {
  btn.addEventListener("click", function () {
    this.closest(".pop-details").style.display = "none";
  });
});